<script lang="ts">
  import {
    Button,
    Column,
    Dropdown,
    FormGroup,
    Grid,
    InlineNotification,
    Row,
  } from "carbon-components-svelte";
  import type APIClient from "src/ts/APIClient";
  import { Helper } from "../../ts/Helper";
  import type { ICanvas, ICanvasOptions } from "src/ts/Interfaces";
  import { optionsData, productId } from "./../../ts/Stores";
  import Templates from "../common/Templates.svelte";
  import PreviewImage from "../common/PreviewImage.svelte";
  import CallToAction from "./CallToAction.svelte";
  import { NCFields } from "./../../ts/NCFields";
  import Fields from "./Fields.svelte";
  import AttributesSection from "./AttributesSection.svelte";

  export let client: APIClient;
  export let canvas: ICanvas;

  let initSuccess: boolean = false;
  let success: boolean = true;
  let errorMessage: string = null;
  let imageSrc: string = null;
  let feedbackColour: string = null;

  let canvasOptions: ICanvasOptions;
  optionsData.subscribe((value) => {
    canvasOptions = value.canvasOptions;
  });

  let ProductId: string;
  productId.subscribe((value) => {
    ProductId = value;
  });

  let ncfields = NCFields.Instance();
  let getImageSrc = async (canvas) => {
    feedbackColour = "orange";
    ncfields.setSettings(canvas);
    await client
      .fetchPreview(canvas)
      .then((src) => {
        imageSrc = src;
        feedbackColour = "lime";
        initSuccess = true;
        success = true;
      })
      .catch((error) => {
        feedbackColour = "red";
        success = false;
        errorMessage = error.message;
      });
  };

  let updatePreview = async () => await getImageSrc(canvas);

  $: getImageSrc(canvas);
</script>

<div class="preview">
  <div class="pane">
    <FormGroup legendText="Preview of your stamp designs" class="step" noMargin>
      {#if !success}
        <InlineNotification kind="error" subtitle={errorMessage} />
      {/if}

      {#if !initSuccess}
        <InlineNotification
          kind="info"
          subtitle="Your stamp preview will show here."
        />
      {/if}

      <PreviewImage
        canvasHeight={canvas.canvasHeight}
        canvasWidth={canvas.canvasWidth}
        sizeInPercentage={canvas.sizeInPercentage}
        {imageSrc}
        {feedbackColour}
      />

      <div class="stack">
        {#if !canvas.hideHideSizeInPercentage}
          <Dropdown
            titleText="Preview Size"
            items={Helper.ToIdTextPair(canvasOptions.sizePercentages)}
            bind:selectedId={canvas.sizeInPercentage}
          />
        {/if}

        <Templates />
      </div>
    </FormGroup>
  </div>

  <div class="pane">
    <FormGroup legendText="Place your order" class="step" noMargin>
      <AttributesSection />
      <CallToAction bind:editMode={ncfields.editMode} {ProductId} />
    </FormGroup>
  </div>
</div>
